import 'core-js/modules/es.array.find';
import 'core-js/modules/es.array.includes';
import 'core-js/modules/es.object.assign';
import 'es6-promise/auto';
import 'whatwg-fetch';

import { useComponentRegistry } from '@bem-react/di';
import { IMetrikaOptions, YMInitializer } from 'client/common/components/yandex-metrika';
import React, { useRef } from 'react';
import Helmet from 'react-helmet';
import { Provider } from 'react-redux';
import { Route, Switch } from 'react-router-dom';

import Meta from 'client/common/components/meta';
import {
    ConfigContextProvider,
    SettingsContextProvider,
    UserContextProvider
} from 'client/common/contexts';
import IndexPage from 'client/common/pages/index';
import { IAppData } from 'client/common/types';
import createStore, { IApplicationState } from 'store';

import 'client/common/components/app/index.css';
import 'client/common/styles/meta.css';
import 'client/common/styles/variables.css';

export interface IAppProps {
    data: IAppData;
    state: IApplicationState;
}

function App({ data, state }: IAppProps) {
    const store = useRef(createStore(state));

    const {
        Footer,
        Prefooter,
        MainMenu,
        SidebarPusher,
        SidebarDimmer,
        Sidebar,
        CasePage,
        SolutionsPage
    } = useComponentRegistry('app');

    const renderCasePage = (props: IAppData) => () => {
        /* eslint-disable */
        const { solutionsUrl, section, seo, solutionsData, shareServices } = props;
        const { solutionSection, solution } = solutionsData;
        const { tasks, products, industries, companySize } = solutionSection;

        return (
            <CasePage
                keywords={seo && seo.keywords}
                solution={solution}
                solutionsUrl={`${solutionsUrl}/${section}`}
                filter={{
                    tasks,
                    products,
                    industries,
                    companySize
                }}
                levels={levels}
                shareServices={shareServices.join(',')}
            />
        );
        /* eslint-enable  */
    };

    const renderSolutionsPage = (props: IAppData) => () => {
        const { solutionsUrl, solutionsData, filterUrl, section } = props;

        const { list, hasMore } = solutionsData;

        const {
            title,
            text,
            tasks,
            industries,
            products,
            companySize
        } = solutionsData.solutionsPage;

        return (
            <SolutionsPage
                section={section}
                title={title}
                text={text}
                solutionsUrl={solutionsUrl}
                filterUrl={filterUrl}
                solutionsList={list}
                hasMore={hasMore}
                filter={{ tasks, industries, products, companySize }}
            />
        );
    };

    const {
        metrikaCounters,
        metrikaCountersParams,
        settings,
        seo,
        og,
        siteSearchUrl,
        language,
        uatraits,
        faviconUrl,
        tld,
        regions,
        mainMenu,
        prefooter,
        levels
    } = data;
    const { phone, text } = settings.footer;
    const phoneData = { phone, text };

    return (
        <div>
            <Provider store={store.current}>
                <SettingsContextProvider data={data}>
                    <ConfigContextProvider data={data}>
                        <UserContextProvider data={data}>
                            <Helmet>
                                <html lang={language} />
                                <link rel="shortcut icon" href={faviconUrl} />
                            </Helmet>
                            <Meta uatraits={uatraits} seo={seo} og={og} />

                            <MainMenu menu={mainMenu} siteSearchUrl={siteSearchUrl} />

                            <Sidebar
                                menu={mainMenu}
                                tld={tld}
                                regions={regions}
                                phoneData={phoneData}
                                siteSearchUrl={siteSearchUrl}
                                />
                            <SidebarDimmer />
                            <SidebarPusher>
                                <Switch>
                                    <Route path="/react" component={IndexPage} />
                                    <Route
                                        exact
                                        path="/solutions/cases"
                                        render={renderSolutionsPage(data)}
                                    />
                                    <Route
                                        path="/solutions/cases/:slug"
                                        render={renderCasePage(data)}
                                        />
                                </Switch>
                                <Prefooter sections={prefooter} />
                                <Footer />
                            </SidebarPusher>

                        </UserContextProvider>
                    </ConfigContextProvider>
                </SettingsContextProvider>
            </Provider>
            <YMInitializer
                accounts={metrikaCounters.map(counter => Number(counter.id))}
                options={prepareMetikaOptions()}
                />
            <script src={data.shareScript} />
        </div>
    );

    function prepareMetikaOptions() {
        return metrikaCounters.reduce((acc: IMetrikaOptions, counter) => {
            acc[counter.id] = { ...metrikaCountersParams, ...counter.params };

            return acc;
        }, {});
    }
}

export default App;
